import PartnerProductCard, { PartnerProductCardProps } from './PartnerProductCard'

export default PartnerProductCard

export { PartnerProductCardProps, PartnerProductCard }
